<template>
  <div class="stuff-page">
    <div class="order_nav">
      <nav-bar
        @goBack="goBack"
        :lefticonshow="true"
        :TextColor="titStyle"
        :bgTrans="true"
        :lefticon="lefticon"
        :titleText="pageTitle"
        :righticonshow="true"
        :righticon="righticon"
        @rightclick="changeIcon"
      >
      </nav-bar>
    </div>
    <div class="stuff-List">
      <img
        src="@/assets/third/secondary/secondary_bg3.png"
        class="stuff_top"
        alt=""
      />
      <div class="stuff-box">
        <div class="stuff-box1">
          <div class="guide-icon">
            <img src="@/assets/third/secondary/secondary_icon3.png" alt="" />
            <div>超值推荐</div>
            <img src="@/assets/third/secondary/secondary_icon3.png" alt="" />
          </div>
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="goodsList"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="别拉了，小巴也是有底线的"
              @load="onLoad"
            >
              <van-row class="supermarket-like" v-if="!showVertical">
                <div
                  class="item-box"
                  v-for="(item, index) in goodsList"
                  :key="index"
                  @click.stop="goDetailBS(item.id)"
                >
                  <div class="item-img">
                    <img
                      class="imgPro"
                      :src="item.thumb"
                      @error="defaultPro()"
                    />
                    <img
                      src="@/assets/third/secondary/secondary_icon41x19.png"
                      alt=""
                    />
                  </div>
                  <div class="item-info">
                    <div class="name">{{ item.name }}</div>
                    <div class="item-desc">
                      <img v-if="item.label" :src="item.label.image" alt="" />
                    </div>
                    <div class="item-price">
                      <div class="item-rig">
                        <div class="i-price">
                          ¥<span>{{ item.activity_min_price }}</span>
                        </div>
                        <img
                          src="@/assets/third/secondary/secondary_cart3.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </van-row>
              <van-row class="supermarket-like item-vertical" v-else>
                <van-col span="12">
                  <div
                    class="item-box"
                    v-for="(item, index) in even(goodsList)"
                    :key="index"
                    @click.stop="goDetailBS(item.id)"
                  >
                    <div class="item-img">
                      <img
                        class="imgPro"
                        :src="item.thumb"
                        @error="defaultPro()"
                      />
                      <img
                        src="@/assets/third/secondary/secondary_icon41x19.png"
                        alt=""
                      />
                    </div>
                    <div class="item-info">
                      <div class="name">
                        <img
                          v-if="item.label"
                          :src="item.label.image"
                          alt=""
                        />{{ item.name }}
                      </div>
                      <div class="item-price">
                        <div class="item-rig">
                          <div class="i-price">
                            ¥<span>{{ item.activity_min_price }}</span>
                          </div>
                          <img
                            src="@/assets/third/secondary/secondary_cart3.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </van-col>
                <van-col span="12">
                  <div
                    class="item-box"
                    v-for="(item, index) in ogg(goodsList)"
                    :key="index"
                    @click.stop="goDetailBS(item.id)"
                  >
                    <div class="item-img">
                      <img
                        class="imgPro"
                        :src="item.thumb"
                        @error="defaultPro()"
                      />
                      <img
                        src="@/assets/third/secondary/secondary_icon41x19.png"
                        alt=""
                      />
                    </div>
                    <div class="item-info">
                      <div class="name">
                        <img
                          v-if="item.label"
                          :src="item.label.image"
                          alt=""
                        />{{ item.name }}
                      </div>
                      <div class="item-price">
                        <div class="item-rig">
                          <div class="i-price">
                            ¥<span>{{ item.activity_min_price }}</span>
                          </div>
                          <img
                            src="@/assets/third/secondary/secondary_cart3.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
export default {
  data() {
    return {
      crossicon: require("@/assets/third/secondary/cross_icon.png"),
      lefticon: require("@/assets/third/secondary/secondary_back3.png"),
      verticalIcon: require("@/assets/third/secondary/vertical_icon.png"),
      righticon: "",
      titStyle: "#fff",
      goodsList: [],
      goodsId: "",
      shopId: "",
      loading: false,
      finished: false,
      isLoading: false,
      page: 0,
      pageSize: 10,
      allList: 11,
      sort_rule: "",
      area_id: "",
      pageTitle: "",
      showVertical: false,
    };
  },
  components: {
    navBar,
  },
  created() {
    this.righticon = this.crossicon;
    let area_id = this.$route.query.id;
    let sort_rule = this.$route.query.sort_rule;
    this.pageTitle = this.$route.query.pageTitle;

    if (area_id) {
      this.area_id = area_id;
    }
    if (sort_rule) {
      this.sort_rule = sort_rule;
    }
  },
  methods: {
    even(list) {
      return list.filter((l, s) => {
        return s % 2 === 0;
      });
    },
    ogg(list) {
      return list.filter((l, s) => {
        return s % 2 != 0;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getGoodsList();
        this.isLoading = false;
      }, 500);
    },
    changeIcon() {
      // item-vertical
      this.showVertical = !this.showVertical;
      this.righticon = this.showVertical ? this.verticalIcon : this.crossicon;
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.goodsList = [];
      this.getGoodsList();
    },
    goDetailBS(id) {
      //商品详情
      let params = {
        goodsId: id,
        shopId: 8,
      };
      this.params(JSON.stringify(params), JSON.stringify(params), "goDetailBS");
    },
    getGoodsList() {
      this.$api
        .post("ongoods/index/goods/area-list", {
          area_id: this.area_id,
          sort_rule: this.sort_rule,
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.list.length > 0) {
            res.list.forEach((item, i) => {
              this.goodsList.push(item);
            });
          }
          this.loading = false;

          if (this.goodsList.length >= this.allList) {
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.finished = true;
          if (err.message) {
            this.$toast(err.message);
          }
        });
    },
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
};
</script>
<style lang="less" scoped>
.stuff-page {
  min-height: 100%;
  background: #ffeeee;
}
.order_nav {
  position: fixed;
  width: 100%;
  // z-index: 99999;
}
.stuff-List {
  min-height: 100%;
  .stuff-box {
    width: 100%;
    top: 8.5rem;
    position: fixed;
    height: 100%;
    z-index: 99999999;
    .stuff-box1 {
      overflow-y: scroll;
      background: #ffeeee;
      height: calc(100% - 8.5rem);
    }
  }
}
.stuff_top {
  z-index: 99999;
  width: 100%;
}
.supermarket-like {
  padding-top: 0.7rem;
  background: #ffeeee;
}
.item-box {
  margin: 0 1rem 1.2rem 1rem;
  display: flex;
  background: #fff;
  padding: 1rem;
  border-radius: 1rem;
  .desc {
    color: #666;
    font-size: 1.2rem;
    // max-height: 20/5rem;
    line-height: 2rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1;
  }
  .item-info {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex: 1;
    .name {
      width: 100%;
      font-weight: bold;
      font-size: 1.4rem;
      color: #333333;
      padding: 0.4rem 0 0 0;
      max-height: 4rem;
      min-height: auto;
      line-height: 2rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    img {
      width: auto;
      height: 1.5rem;
      margin: 0 0.3rem 0 0;
      position: relative;
      display: inline-block;
      top: 0.3rem;
    }
  }
  .item-desc {
    flex: 1;
    margin-top: 0.5rem;
    display: flex;
    & > span {
      color: #fff;
      background: #4534c8;
      font-size: 1rem;
      // transform: scale(0.9);
      display: inline-block;
    }
  }
  .item-rig {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .i-price {
      font-size: 1.2rem;
      color: #fe2929;
      font-weight: bold;
      & > span {
        font-size: 1.4rem;
      }
    }
    & > img {
      width: 2.7rem;
      height: 2.7rem;
    }
  }
}

.item-img {
  width: 11rem;
  height: 11rem;
  margin-right: 1rem;
  position: relative;
  border-radius: 0.6rem;
  overflow: hidden;
  & > img:nth-of-type(1) {
    width: 100%;
    height: 100%;
  }
  & > img:nth-of-type(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 4.6rem;
    height: 2.1rem;
  }
}
.guide-icon {
  display: flex;
  color: #ff0000;
  font-size: 1.4rem;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  margin-top: 0.7rem;
  & > img {
    width: 4.1rem;
    height: 0.7rem;
    margin: 0 1.5rem;
  }
}
.item-vertical {
  & > div:nth-of-type(2) > div {
    margin: 0 1rem 0.9rem 0.5rem;
  }
  .item-img {
    width: 17.3rem;
    height: 17.3rem;
    border-radius: 0;
  }
  .item-price {
    margin-top: 0.9rem;
  }
  .item-box {
    display: inline-block;
    width: 17.25rem;
    padding: 0;
    overflow: hidden;
    margin: 0 0.5rem 0.9rem 1rem;
  }
  .item-info {
    padding: 0.5rem 0.6rem 1rem 0.6rem;
    .name {
      min-height: auto;
    }
  }
  .item-desc {
    margin-bottom: 0.9rem;
    margin-top: 0;
  }
}
</style>